import React, { useState, useContext } from "react";
import { AuthContext } from "../../AuthContext";
import { Link, useNavigate, NavLink } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Loginnew2() {
  const [showPass, setShowPass] = useState(false);
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const { login } = useContext(AuthContext);
  const navigate = useNavigate(); // Better navigation approach

  const validateForm = () => {
    let newErrors = {};
    if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Valid Email is required.";
    if (formData.password.length < 6)
      newErrors.password = "Password must be at least 6 characters long.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e) => {
  e.preventDefault();

  if (validateForm()) {
    setIsSubmitting(true); // Disable button during submission

    try {
      const response = await axios.post("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/loginastrologeremail", {
        Email: formData.email,
        Pass: formData.password,
      });

      console.log("Login Response:", response.data);

      if (response.data.success) {
        login(response.data.token);
        localStorage.setItem("astrologerId", response.data.astrologerId);
        window.location.href = "/astrologerdashboard";
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("An error occurred while logging in.");
    } finally {
      setIsSubmitting(false); // Re-enable button
    }
  }
};


  return (
    <section className="account-section" style={{
      backgroundImage: `url(${require("../../assets/siteimages/astrobackground2245.png")})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      minHeight: "100vh", // full screen height
    }}>
      <div className="tf-container">
        <Tabs className="wd-form-login tf-tab">
          <h5 style={{ fontSize: "32px" }}>Astrologer Login</h5>
          <p style={{ marginBottom: "20px" }}>Use the following form to login to an existing account.</p>
          <TabList className="menu-tab">
  <NavLink to="/astrologerlogin" className="ct-tab" style={{width:"100%"}}>
    <Tab style={{width:"100%"}}>Astrologer</Tab>
  </NavLink>
  <NavLink to="/login" className="ct-tab"  style={{width:"100%"}}>
    <Tab style={{width:"100%"}}>Existing User</Tab>
  </NavLink>
</TabList>
          <div className="content-tab">
            <TabPanel className="inner animation-tab">
              <form onSubmit={handleSubmit}>
                <div className="ip">
                  <label style={{ fontWeight: "bold" }}>Reg. Email address&nbsp;<span>*</span></label>
                  <input
                    type="text"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email Address"
                    style={{ backgroundColor: "#fafafa" }}
                  />
                  {errors.email && <p className="error">{errors.email}</p>}
                </div>
                <div className="ip">
                  <label style={{ fontWeight: "bold" }}>Your Password&nbsp;<span>*</span></label>
                  <div className="inputs-group auth-pass-inputgroup">
                    <input
                      type={showPass ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="New Password"
                      className="input-form password-input"
                      style={{ backgroundColor: "#fafafa" }}
                    />
                    <Link className={`password-addon ${showPass ? "icon-eye" : "icon-eye-off"}`} onClick={() => setShowPass(!showPass)} />
                  </div>
                  {errors.password && <p className="error">{errors.password}</p>}
                </div>
                <button type="submit" disabled={isSubmitting}>
  {isSubmitting ? "Please Wait..." : "Continue As Astrologer"}
</button>
              </form>
            <style>
           {`
             .Toastify__close-button {
               display: none;
             }
           
             .Toastify__toast {
               position: relative;
               padding-right: 30px;
             }
           `}
           </style>
                      <ToastContainer position="bottom-center"
             autoClose={5000}
             hideProgressBar={false}
             newestOnTop={false}
             closeOnClick
             rtl={false}
             pauseOnFocusLoss
             draggable
             pauseOnHover />
            </TabPanel>
            
              <div className="group-ant-choice" style={{marginTop:"15px"}}>
                              <div className="sub-ip">
                              
                Not registered yet? <Link to="/astrologerreg">Register Now</Link>
             
                              </div>
                              <Link to="/forgotpasswordastrologer" className="forgot">
                                Fogot password?
                              </Link>
                            </div>
          </div>
        </Tabs>
      </div>
    </section>
  );
}

export default Loginnew2;